import 'babel-polyfill';
import '../src/student/styles/student.scss';
import 'bootstrap';
import WebpackerReact from 'webpacker-react';
import { ReserveTrialLesson } from '../src/student/pages/participations/reserve_trial_lesson';
import { CreateSubscription } from '../src/student/pages/subscription/create_subscription';
import { UpdateSubscription } from '../src/student/pages/subscription/update_subscription';
import { CreateTicketsParticipations } from '../src/student/pages/tickets/create_participation';
import axios from 'axios';
import { format, addDays, parse } from 'date-fns';
import _ from 'lodash';
import '@fortawesome/fontawesome-free/js/all';
import ja from 'date-fns/locale/ja';

/* rails ujs */
import Rails from 'rails-ujs';
Rails.start();

WebpackerReact.setup({
  ReserveTrialLesson,
  CreateSubscription,
  UpdateSubscription,
  CreateTicketsParticipations,
});

$(function () {
  // 新規登録フォーム
  const change_brand_appearance = (e: any) => {
    if ($(e.target).val() == 'other') {
      $('#user_user_profile_attributes_brand_recognition_others').removeClass(
        'd-none',
      );
    } else {
      $('#user_user_profile_attributes_brand_recognition_others').addClass(
        'd-none',
      );
    }
  };
  $('#user_user_profile_attributes_brand_recognition').on(
    'change',
    change_brand_appearance,
  );
});

// 利用規約チェックボックス
const payjpCheckboxActivate = () =>
  $(
    '.student__subscriptions__payjp_subscriptions-new #payjp_checkout_box input[type="button"]',
  )
    .first()
    .prop('disabled', true);
const payjpCheckboxDeactivate = () =>
  $(
    '.student__subscriptions__payjp_subscriptions-new #payjp_checkout_box input[type="button"]',
  )
    .first()
    .prop('disabled', false);

$(function () {
  $(
    '.student__subscriptions__payjp_subscriptions-new #payjp_checkout_box input[type="button"]',
  )
    .first()
    .prop('disabled', true);
  $('.student__subscriptions__payjp_subscriptions-new .terms_checkbox').on(
    'change',
    (e: any) => {
      if (
        $(
          '.student__subscriptions__payjp_subscriptions-new .terms_checkbox',
        ).is(':checked')
      )
        return payjpCheckboxDeactivate();

      return payjpCheckboxActivate();
    },
  );
});

$(function () {
  // お知らせ既読処理
  $('.btn-notification').on('click', function (this: any, e: any) {
    const notificationId = Number($(this).data('id'));
    const params = {
      notification_id: notificationId,
    };
    const csrfToken = (document.querySelector('[name=csrf-token]') as any)
      ?.content;
    createNotificationReadMark({
      csrfToken: csrfToken,
      params: params,
    });
  });
});

export const createNotificationReadMark = async ({
  csrfToken,
  params,
}: any) => {
  let ok = true;
  const res = await axios
    .post('/student/api/notification_read_marks', params, {
      headers: { 'X-CSRF-TOKEN': csrfToken },
    })
    .catch((error) => {
      ok = false;
      console.log(error.response);
    });

  if (ok) {
    // TODO: 既読完了時の処理
  }
};
